import PasteOptionViewState from '../store/schema/PasteOptionViewState';
import { IPoint } from 'office-ui-fabric-react/lib/utilities/positioning';
import { action } from 'satcheljs/lib/legacy';

export default action('setPasteOptionPosition')(function setPasteOptionPosition(
    viewState: PasteOptionViewState,
    position: IPoint
) {
    viewState.position = position;
});
